module.exports = __webpack_public_path__ + "img/delete.f5541120.svg";